import i18n from "../core/plugins/vue-i18n";

export var globalVariables = {
    '{user.name}' : "",
    '{user.id}' : "",
}

function convertToCorrectFormat(array){
    let convert = {}
    for (let i in array) {
        let val = array[i];
        if (i === 'attribute'){
            let alt = i18n.t('attributes' + i);
            if (alt !== 'attributes' + i){
                val = alt;
            }
        }

        convert[`{${i}`] = val;
    }
    return convert
}

export function translate(code){
    if (! code) return '';

    if (typeof code == "string") {
        if (code.startsWith(' ')){
            code = JSON.parse(code.substring(1));
        }else{
            code = {
                message : code,
                variables : {}
            }
        }
    }

    let values = {...globalVariables , ...(convertToCorrectFormat(code.variables ?? {}))};
    return (i18n.t(code.message.toString())).replace(/[{](\w|\.)+[}]/gm , function(a){return values[a]??a})
}

export function responseTranslate(response){
    response.message = translate(response);
    delete response.variables

    for (let i in response.errors ?? []) {
        if (typeof response.errors[i] == "object"){
            for (let ii in response.errors[i]){
                response.errors[i][ii] = translate(response.errors[i][ii])
            }
        }else{
            response.errors[i] = translate(response.errors[i])
        }

    }

    return response;
}



export default {
    install(Vue) {
        Vue.prototype.$translate = translate;
        Vue.prototype.$responseTranslate = responseTranslate;
    }
}